var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.7507 21.167V18.6972H71.1012C72.0624 18.6972 72.4882 19.1595 72.4882 19.9382C72.4882 20.6925 72.0624 21.167 71.1012 21.167H69.7507ZM74.2402 19.9382C74.2402 18.466 73.2182 17.3101 71.1742 17.3101H68.0474V25.8025H69.7507V22.5418H71.1742C73.3642 22.5418 74.2402 21.2278 74.2402 19.9382Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9513 19.9503C79.9513 20.7168 79.5254 21.2157 78.5764 21.2157H77.1529V18.7215H78.5764C79.5254 18.7215 79.9513 19.196 79.9513 19.9503ZM75.4496 17.3101V25.8025H77.1529V22.4932H77.9559L79.8296 25.8025H81.8006L79.7688 22.3593C81.1315 21.9943 81.7033 20.948 81.7033 19.9138C81.7033 18.4903 80.6813 17.3101 78.6373 17.3101H75.4496Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5295 21.532C91.5295 18.9892 89.6071 17.1885 87.1859 17.1885C84.7891 17.1885 82.8302 18.9892 82.8302 21.532C82.8302 24.087 84.7891 25.8877 87.1859 25.8877C89.5949 25.8877 91.5295 24.087 91.5295 21.532ZM84.5822 21.532C84.5822 19.8043 85.6408 18.7215 87.1859 18.7215C88.7189 18.7215 89.7774 19.8043 89.7774 21.532C89.7774 23.2597 88.7189 24.3669 87.1859 24.3669C85.6408 24.3669 84.5822 23.2597 84.5822 21.532Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17.3018H30.21L38.71 30.0618V42.8118H37.01L20 17.3018Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1322 30.4537C53.8952 29.9438 54.7923 29.6717 55.71 29.6717C56.3197 29.6704 56.9237 29.7895 57.4872 30.0222C58.0507 30.2549 58.5628 30.5967 58.9939 31.0278C59.425 31.4589 59.7668 31.971 59.9995 32.5345C60.2322 33.098 60.3513 33.702 60.35 34.3117C60.35 35.2294 60.0779 36.1265 59.568 36.8896C59.0582 37.6526 58.3335 38.2473 57.4856 38.5985C56.6378 38.9497 55.7049 39.0416 54.8048 38.8625C53.9047 38.6835 53.0779 38.2416 52.429 37.5927C51.7801 36.9438 51.3382 36.117 51.1592 35.2169C50.9801 34.3168 51.072 33.3839 51.4232 32.5361C51.7744 31.6882 52.3691 30.9635 53.1322 30.4537Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.21 42.8117L38.71 42.8118V30.0618L38.71 17.3018H64.22V25.8018H47.21V42.8117Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteV);
export default __webpack_public_path__ + "static/media/white-v.39684624b8ecaf11e4e433d33ab8428d.svg";
export { ForwardRef as ReactComponent };